export const globalSliderConfig = {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    pagination: false,
    speed: 2000,
    arrows: true,
    classes: {
        arrow: 'splide__arrow splide__arrow--green',
    },
    breakpoints: {
        768: {
            perPage: 2,
            gap: '.7rem',
        },
        600: {
            perPage: 1,
            gap: '.7rem',
        },
    },
};
